(function enableViewTransitions() {
    if (typeof document === "undefined") return;
    var style = document.createElement("style");
    style.textContent = "@view-transition { navigation: auto; }";
    document.head.appendChild(style);
})();

//# sourceMappingURL=index.95c715c2.js.map
